import { Box, Link, styled, Typography, typographyClasses } from '@mui/material';
import { getSignInFooterInformation, WEBAPP_BRAND } from 'config';

const SignInFooter = () => {
  return (
    <StyledContactWrapperBox>
      <StyledInfoText variant="body1">
        Door aan te melden ga je akkoord met de{' '}
        <StyledLink href={termsOfUse} target="_blank" rel="noreferrer">
          gebruiksvoorwaarden
        </StyledLink>{' '}
        en de{' '}
        <StyledLink href={privacyStatement} target="_blank" rel="noreferrer">
          privacyverklaring.
        </StyledLink>
      </StyledInfoText>
      <StyledContactText variant="body1" display="block">
        Neem contact op met {client} support
      </StyledContactText>
      <StyledContactText variant="body1" display="block">
        {phoneNumber} als je een probleem hebt tijdens het inloggen.
      </StyledContactText>
    </StyledContactWrapperBox>
  );
};

const { phoneNumber, termsOfUse, privacyStatement, client } =
  getSignInFooterInformation(WEBAPP_BRAND);

const StyledContactWrapperBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  marginTop: theme.spacing(10),
}));

const StyledContactText = styled(Typography)(({ theme }) => ({
  [`&.${typographyClasses.root}`]: {
    color: theme.palette.lwBlack[100],
  },
}));

const StyledInfoText = styled(Typography)(({ theme }) => ({
  [`&.${typographyClasses.root}`]: {
    color: theme.palette.lwBlack[100],
  },
  display: 'block',
  marginBottom: theme.spacing(8),
  marginTop: theme.spacing(2.5),
}));

const StyledLink = styled(Link)(({ theme }) => ({
  color: theme.palette.lwBlack[100],
  textDecorationColor: theme.palette.lwBlack[100],
}));

export { SignInFooter };
